import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { Globe } from 'lucide-react'
import type { Language } from '../i18n'

// Language names are written in their own language, so they never change
// with the selection and are not translation keys.
const OPTIONS: { value: Language; label: string }[] = [
  { value: 'no', label: 'Norsk' },
  { value: 'en', label: 'English' },
]

export default function LanguageSwitcher() {
  const { i18n } = useTranslation()
  const active: Language = i18n.language === 'en' ? 'en' : 'no'

  return (
    <label className="flex items-center gap-1 p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-dark-card transition-colors cursor-pointer">
      <Globe className="w-5 h-5 text-gray-600 dark:text-gray-400" aria-hidden="true" />
      <select
        data-testid="language-switcher"
        aria-label="Språk / Language"
        value={active}
        onChange={e => i18n.changeLanguage(e.target.value)}
        className="bg-transparent text-sm text-gray-700 dark:text-gray-300 border-none focus:ring-0 cursor-pointer pr-6 py-0"
      >
        {OPTIONS.map(o => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  )
}

// Pages outside Layout have no header, so they get the switcher in a corner
// (#714 AC1: login and registration must offer it too).
const PUBLIC_PATHS = ['/login', '/register', '/forgot-password', '/reset-password', '/subscribe']

export function PublicLanguageSwitcher() {
  const { pathname } = useLocation()
  if (!PUBLIC_PATHS.includes(pathname)) return null
  return (
    <div className="fixed top-4 right-4 z-50 bg-white/80 dark:bg-gray-800/80 rounded-lg shadow-sm">
      <LanguageSwitcher />
    </div>
  )
}
